import * as React from 'react';
import { Id, Bem, addClass } from '../../utils';
import './HeaderMenuGroup.css';
const bem = Bem.create('vai-header-menu-group');
export class HeaderMenuGroup extends React.Component {
    render() {
        const { htmlId, dataTa, title, children, className, ...rest } = this.props;
        const id = Id.create(htmlId, ['header dropdown group']);
        return (React.createElement("div", Object.assign({ id: id.toString(), "data-ta": dataTa, className: addClass(bem.block(), className) }, rest),
            React.createElement("div", { id: id.copyWith(['title']).toString(), className: bem.element('title')() }, title),
            children));
    }
}
//# sourceMappingURL=HeaderMenuGroup.js.map